import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef, isDevMode, AfterViewInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, NavigationCancel, NavigationError, ActivatedRoute } from '@angular/router';
import { AuthState } from './core/auth/auth-state';
import { AuthService } from './core/auth/auth.service';
import { MainMenuService } from './shared/services/mainmenu.service';
import { DOCUMENT } from '@angular/common';
import { GeneralService } from './shared/services/general.service';
import { Subscription } from 'rxjs';
import { HomeController } from './modules/home/home.controller';
import { AppLoadingService } from './shared/services/apploading.service';
import config from 'src/config.json';
import { ModalService } from './shared/services/modal.service';
import { ModalAction } from './shared/models/action';
import { VimeoService } from './core/services/vimeo.service';

declare var window:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

  private deepUrl: string = '';
  private canGoDeep: boolean = false;
  private goingDeep: boolean = false;
  private authFinishInit: boolean = false;
  
  generalDataLoaded: boolean = false;
  appLoading: boolean = true;
  lastRouterClass:any = false;

  protected appLoadingSubscription: Subscription;

  constructor(
    @Inject(DOCUMENT) private doc: any,
    private mms: MainMenuService,
    private mod : ModalService,
    private authService: AuthService,
    private router: Router,
    protected activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private gs: GeneralService,
    private als: AppLoadingService,
    protected control: HomeController,
    protected vimeo : VimeoService
  ) {

    this.gs.loadPublicSettings();

    this.router.events
      .subscribe((event) => {
          if (event instanceof NavigationStart) {
              this.als.setLoaded(false,'navigate');
              this.gs.setStartUrl(event.url);
              let parts = decodeURI(event.url).split('/');

              if(typeof parts[1] ==='undefined' || parts[1]!='openModal')
                this.mod.closeAll();

              if(typeof parts[1] !=='undefined'){
                  if(parts[1]=='openModal'){

                    let params:any = {id:parts[3] || null};
                    let component = parts[2];
                    if(event.url.indexOf('?')>-1){
                      var url = event.url.substring(event.url.indexOf('?')+1);

                      params = JSON.parse('{"' + decodeURI(url).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
                      if(params?.json)
                        params = { params : JSON.parse(decodeURIComponent(params.json))};

                      component = parts[2].substring(0, component.indexOf('?'));
                    }
                    this.mod.openModal(new ModalAction('' , '', component, params));
                    return false;
                  }
                  this.gs.setDefaultModule(parts[1], this.router);
                  const elBody = document.getElementsByTagName("body")[0];
                  
                  if(this.lastRouterClass)
                    elBody.classList.remove(this.lastRouterClass);
                  
                  this.lastRouterClass = parts[2] || 'home';
                  if(this.lastRouterClass)
                    elBody.classList.add(this.lastRouterClass);
                  
              }
          } else if(
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError){
              this.als.setLoaded(true,'navigate');
          }
      },
      () => {
        this.als.setLoaded(true,'navigate');
      });
  }

  ngOnInit() {
  }
  ngAfterViewInit(): void {

    //this.mms.addButtons(this.authService.getDefaultAction());
    this.proccessDeepLink();
    this.prepareAuthStateObservation();
    this.setAssets();

    this.appLoadingSubscription = this.als.appLoading$.subscribe(result => {

      this.appLoading = !this.als.isAllLoaded();

      let dataLoaded = this.gs.getBase() == '/' || (this.authService.getActualAuthState().state === AuthState.SIGNED_IN && !!result?.confirmSignedIn);

      if(this.generalDataLoaded != dataLoaded)
        this.generalDataLoaded = dataLoaded;

      this.cdr.detectChanges();       

    });
  }

  ngOnDestroy(){
    this.appLoadingSubscription?.unsubscribe();
  }

  private setAssets() {
    const head = this.doc.getElementsByTagName('head')[0];
    head.appendChild(this.createEl('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: (isDevMode()? '/' : config.appUrl)+'assets/favicon/favicon-16x16.png' }));
    head.appendChild(this.createEl('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: (isDevMode()? '/' : config.appUrl)+'assets/favicon/favicon-32x32.png' }));
    head.appendChild(this.createEl('link', { rel: 'apple-touch-icon', sizes: '180x180', href: (isDevMode()? '/' : config.appUrl)+'assets/favicon/apple-touch-icon.png' }));
    head.appendChild(this.createEl('link', { rel: 'manifest', href: (isDevMode()? '/' : config.appUrl)+'assets/favicon/site.webmanifest' }));
    head.appendChild(this.createEl('link', { rel: 'mask-icon',color : '#1240af', href: (isDevMode()? '/' : config.appUrl)+'assets/favicon/safari-pinned-tab.svg' }));
  }

  private createEl(type, props) {
    const e = this.doc.createElement(type);
    for (var k in props)
      if (props.hasOwnProperty(k)) {
        e[k] = props[k];
      }
    return e;
  }

  private async prepareAuthStateObservation() {
    //this.httpService.get(API.status, '');

    await this.authService.getAuthStateChange().subscribe(
      authState => {
        const elBody = document.getElementsByTagName("body")[0];
                  
        if(authState.state === AuthState.SIGNED_IN){
          elBody.classList.add('signedin');
        } else
          elBody.classList.remove('signedin');

        if(authState.state === AuthState.SIGNED_OUT){
          this.gs.avatarChange(false);
          this.gs.doClearGeneralData();
        }

        if (this.authFinishInit
          && this.canGoDeep
          && this.deepUrl != '') {

          this.goDeepLink()
        } else if (this.authService.isUserAlreadyCheck()) {
          
          if (authState.state === AuthState.SIGN_IN) {
            this.router.navigate(['openModal','AuthenticatorComponent']);

          } else if (authState.user != null && authState.state === AuthState.SIGNED_IN) {
            
            this.gs.confirmSignedIn(authState.user)
            .catch(err => {
              this.authService.signOut();
              this.gs.authChecked.next(true);
            });
            //.finally(() => );

          } else if (authState.state === AuthState.SIGNED_OUT) {
            
            if(this.router.url!='/')
              this.control.init();
            
            if(this.router.url!='/' && !this.router.url.startsWith('/realtor') && !this.router.url.startsWith('/admin') && !this.router.url.startsWith('/builder') && !this.router.url.startsWith('/faq'))
              this.router.navigate(['/']);

              this.als.setLoaded(true,'confirmSignedIn');
              this.gs.authChecked.next(true);
          } else if (authState.state === AuthState.CONFIRM_SIGN_UP) {
            this.router.navigate(['openModal','AuthenticatorComponent']);
            //this.router.navigate(['/confirmSignUp']);
            this.gs.authChecked.next(true);
          }
          this.authFinishInit = true;
        } else {
          this.authService.checkAuthenticatedUser();
        }
      }
    );
  }

  private proccessDeepLink() {
    this.router.events.subscribe(e => {
      if (e instanceof NavigationStart) {
        if (!this.goingDeep && e.url && (e.url.startsWith('/emailsignup') || e.url.startsWith('/perfil') || e.url.startsWith('/signUpRealestate') || e.url.startsWith('/confirmUser'))) {
          this.deepUrl = e.url;
        }
      } else if (e instanceof NavigationEnd) {
        this.goingDeep = false;
        this.canGoDeep = true;
        if (this.authFinishInit) {
          this.goDeepLink();
        }
        window.scrollTo(0, 0);
      }
    });
  }

  private goDeepLink() {
    if (this.canGoDeep && (this.deepUrl != '')) {
      const url = this.deepUrl;
      this.deepUrl = '';

      this.canGoDeep = false;
      this.goingDeep = true;
      this.router.navigateByUrl(url);
      if(url.startsWith('/confirmUser'))
        this.authService.changeAuthState(AuthState.CONFIRM_SIGN_UP, null);
    }
  }

}

window.mobileAndTabletCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};